module.exports = "img/tick.fc8e192.svg";